<template>
  <div>
    <div class="card-body print-form" id="receiptDataBillA4">
      <b-row class="">
        <b-col cols="12">
          <table style="width: 100%;">
            <tr>
              <td class="description" style="color: black; text-align: center">
                <span>
                  <h6
                    class="mb-0 tx-rubik text-center company_name text-uppercase shop-header"
                  >
                    {{ GetSiteName }}
                  </h6>
                </span>
              </td>
            </tr>

            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 mb-0 tx-rubik tx-12 text-center">
                  {{
                    sales_info.shop.address
                      ? sales_info.shop.address.address_line1
                      : ""
                  }},
                  {{
                    sales_info.shop.address
                      ? sales_info.shop.address.address_line2
                      : ""
                  }},
                  {{
                    sales_info.shop.address ? sales_info.shop.address.city : ""
                  }},
                  {{
                    sales_info.shop.address
                      ? sales_info.shop.address.country.name
                      : ""
                  }}
                </h6>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 tx-12 tx-rubik text-center">
                  {{
                    sales_info.shop.contact
                      ? sales_info.shop.contact.telephone
                      : ""
                  }}
                  |
                  {{
                    sales_info.shop.contact ? sales_info.shop.contact.phone : ""
                  }}
                </h6>
              </td>
            </tr>
          </table>

          <hr class="hor_line" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold">
          <table style="width: 100%;">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Date
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ sales_info.date | formatDate }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Biller
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ sales_info.biller.first_name }}</span
                >
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Reference
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ sales_info.reference_number }}
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <hr style="b margin-bottom: 10px" />

      <b-row>
        <b-col>
          <table style="width: 100%;">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th class="description" style="color: black; text-align: left">
                  Item
                </th>
                <th
                  class="unit-price unit-price-text"
                  style="color: black; text-align: center"
                >
                  price
                </th>
                <th
                  class="quantity"
                  style="color: black; text-align: center; padding: 0px"
                >
                  Qty
                </th>
                <th class="discount" style="color: black; text-align: right">
                  Discount
                </th>
                <th
                  class="amount unit-price-text"
                  style="color: black; text-align: right"
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(salesInfo, index) in sales_info.saleItems"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <span class="tx-bold mb-2 f-15" style="color: black">
                    <!-- {{ product.name }} -->
                    {{ salesInfo.product.name }}
                  </span>
                  -
                  {{ salesInfo.unit.name }}
                </td>
                <td
                  class="unit-price"
                  style="color: black; text-align: center; width: 80px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ salesInfo.amount }}
                  </span>
                </td>
                <td
                  class="quantity"
                  style="color: black; text-align: center; width: 30px"
                >
                  <span
                    style="color: black; text-align: center"
                    class="tx-rubik"
                  >
                    {{ salesInfo.quantity }}
                  </span>
                </td>
                <td
                  class="discount"
                  style="color: black; text-align: right; width: 80px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ sales_info.discount_amount }}
                  </span>
                </td>
                <td
                  class="amount"
                  style="color: black; text-align: right; width: 100px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ sales_info.grand_total }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table style="width: 100%;">
            <tr>
              <td
                colspan="2"
                class="description"
                style="color: black; text-align: left"
              >
                <hr style="border-top: solid 1px; margin: 1px" />
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  No of items - {{ sales_info.total_items }}
                </span>
              </td>
            </tr>
            <tr>
              <td
                class="description"
                style="color: black; text-align: left; padding-top: 10px"
              >
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Total
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right; padding-top: 10px"
              >
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ sales_info.total }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Discount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ sales_info.discount_amount }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left; ">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Net Amount
                </span>
                <hr style="border-top: solid 1px; margin: 1px" />
              </td>
              <td class="unit-price" style="color: black; text-align: right; ">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ sales_info.grand_total }}
                </span>
                <hr style="border-top: solid 1px; margin: 1px" />
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Sale Type
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ sales_info.sale_type }}
                </span>
              </td>
            </tr>

            <tr>
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Status
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ sales_info.status }}
                </span>
              </td>
            </tr>

            <tr style="margin-top: 10px">
              <td colspan="2">
                <h4 style="text-align: center; margin-top: 20px; color: black">
                  <!-- நன்றி மீண்டும் வருக ! -->
                  Thank You Come Again!
                </h4>
              </td>
            </tr>

            <tr style="margin-top: 10px">
              <td colspan="2" style="margin-top: 20px">
                <a
                  href="https://nallaienterprise.com/"
                  style="text-align: center; display:flex; justify-content: center; color: black "
                >
                  https://nallaienterprise.com/
                </a>
              </td>
            </tr>

            <tr>
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 20px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>

    <b-btn
      @click="print"
      variant="primary"
      class="mt-2 pt-3 pb-3 font-poppins font-weight-bold w-100"
      >Print</b-btn
    >
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BillTemplate from "../Payment/BillTemplate.vue";

export default {
  name: "PrintBill",
  props: {},
  components: {
    BillTemplate,
  },
  computed: {
    ...mapState("sales", ["sales_info"]),
    ...mapGetters("siteSettings", ["GetSiteName"]),
  },
  methods: {
    printa4size() {
      setTimeout(() => {
        this.$htmlToPaper("receiptDataBillA4");
      }, 1000);
      setTimeout(() => {
        this.$store.dispatch("bill/cancelBill");
      }, 2000);
    },
  },
};
</script>
<style>
.description {
  width: 80px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}
#receiptData {
  width: 100%;
  background: white;
}
</style>
